// Styling sizes for media queries
export enum STYLING_SIZES {
  LARGE_TABLET = '1170px', // about 12 times per project
  SMALL_TABLET = '1070px', // about 9 times per project
  LARGE_PHONE = '800px', // about 12 times per project
  SMALL_PHONE = '400px', // about 1 time per project
}

export enum PAGES_TITLES {
  HOME = 'Home',
  ADVANTAGES_OF_STUDYING_IN_BELARUS = 'Advantages of Studying in Belarus',
  NOT_FOUND = '404',
}

//Button Styling Variant
export enum BUTTON_VARIANT {
  CONTAINED = 'contained',
  OUTLINED = 'outlined',
}

//Default Sizes System
export enum DEFAULT_SIZES {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
}
